<div class="card kpi-red">
    <div class="card-body kpi-card">
        <h5 class="card-title">Mensualités</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €/mois</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.monthly | number: '1.0-0' }} <span class="fs-7"> €/mois</span>
            </ng-container>
        </p>
    </div>
</div>
